import { takeEvery } from 'redux-saga'
import { put, call, all, select } from 'redux-saga/effects'
import { selectProjectSelector } from 'selectors'
import { startAutosaveSagaAction, notifyHoneybadgerAction, hideMobileStartAction } from 'actions/applicationActions'
import { expandProjectAction } from 'actions/projectActions'
import { SELECT_PROJECT } from 'actions/projectActionTypes'
import { notificationAction } from 'actions/notificationActions'
import { changeProject } from 'sagas/changeProjectSaga'
import getDocument from 'helpers/databases/getDocument'
import { getSettings } from 'sagas/setupProjectsSaga/findBySelector'
import createDocument from 'helpers/databases/createDocument'
import defaultSettings, { addDefaultSettings } from 'helpers/defaultSettings'

export function * selectProject(action) {
  try {
    const { database, showMobileStart, active } = yield select(selectProjectSelector)

    if (showMobileStart) {
      yield call(changeProject, action)
      return yield put(hideMobileStartAction())
    }

    let [project, settings] = yield all([
      call(getDocument, database, action.id),
      call(getSettings, database)
    ])

    if (!settings) {
      yield call(createDocument, database, defaultSettings)
      settings = defaultSettings
    } else settings = addDefaultSettings(settings)

    yield put(expandProjectAction(project, false, active, false, settings))
    yield put(startAutosaveSagaAction())
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: SELECT_PROJECT, skipThrow: true }))
    yield put(notificationAction('Could not open project', SELECT_PROJECT))
  }
}

export function * watchSelectProject() {
  yield * takeEvery(SELECT_PROJECT, selectProject)
}



// WEBPACK FOOTER //
// ./src/sagas/selectProjectSaga.js